import React from "react";
import { DisplayProductsType } from "../components/DisplayProductType";

export function MBoards(): JSX.Element {
    return <div>{DisplayProductsType("MB")}</div>;
}

export default MBoards;
